import { http, HttpResponse } from 'msw'

export const mockUpdateB2BConfigurations = http.put(
  '/my-business/api/agency/v1/*/:agencyChainAlphaId/b2b-configurations',
  () => {
    return HttpResponse.json(
      { timestamp: new Date().toISOString() },
      { status: 200 },
    )
  },
)
